type TColorProp = string | string[]
interface ShineBorderProps {
  borderRadius?: number
  borderWidth?: number
  duration?: number
  color?: TColorProp
  className?: string
  bgColor?: string
  children: React.ReactNode
}

export default function ShineBorder({
  borderRadius = 10,
  borderWidth = 1,
  duration = 14,
  color = "#fff",
  bgColor = "#fff",
  className,
  children,
}: ShineBorderProps) {
  return (
    <div
      style={
        {
          "--border-radius": `${borderRadius}px`,
          // background: "linear-gradient(248deg, #5F05DE 4.53%, #340378 52.76%, #000 111.7%)",
          backgroundSize: "200% 200%",
          position: "relative",
          display: "grid",
          // minHeight: "60px",
          width: "fit-content",
          // minWidth: "300px",
          placeItems: "center",
          borderRadius: "var(--border-radius)",
          backgroundColor: "white",
          padding: `${borderWidth}px`,
          color: "white",
          textAlign: "center",
        } as React.CSSProperties
      }
    >
      <div
        style={
          {
            "--border-width": `${borderWidth}px`,
            "--border-radius": `${borderRadius}px`,
            "--border-radius-child": `${borderRadius * 0.2}px`,
            "--shine-pulse-duration": `${duration}s`,
            "--mask-linear-gradient":
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            "--background-radial-gradient": `radial-gradient(transparent,transparent, ${
              !Array.isArray(color) ? color : color.join(",")
            },transparent,transparent)`,
            backgroundColor: "white",
            position: "absolute",
            inset: "0",
            aspectRatio: "1 / 1",
            height: "100%",
            width: "100%",
            borderRadius: "var(--border-radius)",
            padding: "var(--border-width)",
            willChange: "background-position",
            content: '""',
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            backgroundImage: "var(--background-radial-gradient)",
            backgroundSize: "300% 300%",
            mask: "var(--mask-linear-gradient)",
            animation: "shine-pulse var(--shine-pulse-duration) infinite linear",
          } as React.CSSProperties
        }
      />
      <div
        style={{
          zIndex: 1,
          height: "100%",
          width: "100%",
          borderRadius: `${borderRadius}px`,
          backgroundColor: bgColor,
          placeContent: "center",
        }}
      >
        {children}
      </div>
    </div>
  )
}
